module.exports = __webpack_public_path__ + "img/yiwen@2x.de45542b.png";